import { Color } from '@medly-components/theme';

const royalBlue: Color = {
    50: '#E6F1FA',
    100: '#B0D2EE',
    200: '#8ABCE6',
    300: '#559EDB',
    400: '#348BD4',
    500: '#016EC9',
    600: '#0164B7',
    700: '#014E8F',
    800: '#013D6F'
};

export default royalBlue;
